/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from '../../../services'
import { AuthProviderModel } from "../../../pages/guarded/features/authProvider/models/AuthProviderModel";
import { AuthProviderHistoryModel } from "../../../pages/guarded/features/authProvider/models/AuthProviderHistoryModel";

 
export const getAllAuthProvider = createAsyncThunk('authProvider/getAllAuthProvider', async (_, { rejectWithValue }) => {
    try { 
        const data = await api.authProvider.getAllAuthProvider();
        const formattedData = data.Records.map((record) => ({
            ...AuthProviderModel, // Default values from the model
            ...record, // Merge the response data with the model defaults
          }));
        return Promise.resolve(formattedData)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})

export const getAuthProviderHistory = createAsyncThunk('authProvider/getAuthProviderHistory', async (params, { rejectWithValue }) => {
    try { 
        const data = await api.authProvider.getAuthProviderHistory(params);
        const formattedHistory = data.map((item) => ({
            ...AuthProviderHistoryModel, 
            ...item, // Actual data merged with model defaults
            Record: {
              ...AuthProviderHistoryModel.Record,  
              ...item.Record
            }
          }));
    
         return Promise.resolve(formattedHistory)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
